<abc-drawer
  fxFill
  fxLayout="column"
  class="drawer"
  position="before"

  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [shading]="shaderEnabled"
  [(opened)]="menuOpened"
  >
  <!-- SideNav -->
  <div fxLayout="column" id="menu" content="abcDrawerContainer">
    <abc-toolbar fxLayout="row" id="navigation-header">
      <dxi-item location="before" widget="dxButton" widget="dxButton">
        <button mat-button class="menu-button" (click)="toggleMenu($event)">
          <mat-icon style="color: var(--button-text-color); font-size: 32px">{{
            menuOpened ? 'menu_open' : 'menu'
          }}</mat-icon>
        </button>
      </dxi-item>
      <dxi-item location="center" cssClass="header-title" html="{{ dtLogo }}"></dxi-item>
    </abc-toolbar>
    <div fxLayout="row" class="menu-container">
      <abc-tooltip [target]="target" [(visible)]="isVisible">
        <div *dxTemplate="let data = data; of: 'content'">
          <span>{{ tooltipContent }}</span>
        </div>
      </abc-tooltip>
      <abc-tree
        #treeview
        [items]="navigation"
        keyExpr="path"
        selectionMode="single"
        [focusStateEnabled]="false"
        expandEvent="click"
        [displayExpr]="'text'"
        [itemsExpr]="'items'"
        (onContentReady)="onContentReady($event)"
        (onItemClick)="onMenuItemClick($event)"
        width="100%"
        >
      </abc-tree>
    </div>
  </div>
  <!-- End SideNav -->
  <div fxFlex="100" fxLayout="column" class="container" content="abcDrawerContent">
    <div id="container">
      <header fxLayout="row" id="header">
        <abc-toolbar class="header-toolbar" fxLayout="column" fxLayoutAlign="center center">
          <dxi-item
            style="width: inherit; font-weight: 700"
            [cssClass]="headerMainTitleCSS()"
            location="before"
            [text]="titleApplication"
            >
          </dxi-item>
          <dxi-item location="center" [text]="companyName"> </dxi-item>
          <dxi-item style="margin-right: 10px" location="after">
            <abc-switch
              class="language-switch"
              [value]="isDefaultLanguageDe"
              (onValueChanged)="changeLanguage($event.value)"
              [switchedOffText]="'De'"
              [width]="'100%'"
              [switchedOnText]="'En'"
            ></abc-switch>
          </dxi-item>
          <dxi-item location="after">
            <div class="user-info">
              @if (currentUser?.hasAvatar) {
                <div class="image-container"></div>
              }
              @if (!currentUser?.hasAvatar) {
                <div>
                  <img class="userLogo" src="assets/images/custom/User.svg" />
                </div>
              }
              <div class="user-name">
                {{ currentUser?.displayName }}
              </div>
            </div>
          </dxi-item>
          <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
            <img class="contextMenuHeader" src="assets/images/custom/ContextMenu.svg" />
          </dxi-item>
        </abc-toolbar>
        <abc-context-menu
          class="settings-context-menu"
          target=".contextMenuHeader"
          showEvent="dxclick"
          [items]="contextMenuItems"
          [position]="{ my: 'top right', at: 'bottom right' }"
          >
        </abc-context-menu>
      </header>
      <abc-scroll-view>
        <router-outlet fxFill fxLayout="row" (activate)="onRouterOutletActivate()"></router-outlet>
      </abc-scroll-view>
    </div>
    @if (isFavoriteOpen) {
      <favorite-list #favorites (closebtn)="closeFavorites()"> </favorite-list>
    }
  </div>
  <!-- Body -->
</abc-drawer>

<abc-toast #toast [animation]="toastAnimation" [type]="'custom'" [contentTemplate]="toastTemplate">
  <div *dxTemplate="let data of 'success'" class="successful-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
  <div *dxTemplate="let data of 'error'" class="failure-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
  <div *dxTemplate="let data of 'info'" class="info-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
</abc-toast>
